var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-container',[_c('el-main',[_c('app-main')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }